import { render, staticRenderFns } from "./TestBookingManage.vue?vue&type=template&id=5ebbb0e9&scoped=true"
import script from "./TestBookingManage.vue?vue&type=script&lang=js"
export * from "./TestBookingManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../Vue/course_selecttion_v3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebbb0e9",
  null
  
)

export default component.exports